import { Component, OnInit, signal } from '@angular/core';
import { SessionService } from '@app/core/services/client-services/session-service/session.service';
import { DialogService } from '@ngneat/dialog';
import { GetMeQuotasResponse } from 'api/models';
import { MatButton } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-quotas',
    templateUrl: './quotas.component.html',
    styleUrls: ['./quotas.component.scss'],
    imports: [MatButton, TranslateModule],
})
export class QuotasComponent implements OnInit {
    public quotas = signal<GetMeQuotasResponse | undefined>(undefined);
    constructor(
        public sessionService: SessionService,
        public dialog: DialogService
    ) {}

    async ngOnInit() {
        this.quotas.set(await this.sessionService.getQuotas(true));
        console.log(this.quotas());
    }
}
